import Swiper from 'swiper';
import { Navigation } from 'swiper';
import $ from 'jquery'; // Ensure jQuery is imported

export function newsSlider() {
    $('.news-slider').each(function() {
        let block = $(this);
        let slider = $(this).find('.news-slider__slider');
        const newsSlider = new Swiper(slider.get(0), {
            // Common parameters
            loop: false,
            spaceBetween: 0,
            autoHeight: true,
            navigation: {
                nextEl: block.find('.swiper-button-next').get(0),
                prevEl: block.find('.swiper-button-prev').get(0),
            },
            // Responsive breakpoints
            breakpoints: {
                // When window width is >= 1024px (desktop)
                1024: {
                    slidesPerView: 3,
                },
                // When window width is >= 768px and < 1024px (tablet)
                768: {
                    slidesPerView: 2,
                },
                // When window width is < 768px (mobile)
                0: {
                    slidesPerView: 1,
                },
            },
            modules: [Navigation],
        });
    });
    
}
